<template>
  <section>
    <div v-if="loadingStatus">
      <ContentLoader :size="4"></ContentLoader>
    </div>
    <div v-else>
      <div v-for="(d, i, index) in sessionDates" :key="i" class="mb-10">
        <!-- <router-link
          :to="{ name: 'UserSessionDetails', params: { id: d.session_id } }"
          v-if="d.entity_type == 2"
        >
          <div
            class="xl:flex xl:p-5 p-3 bg-white ring-1 ring-gray-darkest m-1 duration-500 shadow-all rounded-lg"
            slot="reference"
          >
            <img
              class="object-cover xl:h-16 xl:w-16 w-full h-full rounded-lg"
              :src="baseUrlSrc(d.course_thumbnail)"
              alt="..."
              @error="defaultImage"
            />
            <div class="px-2">
              <h5
                class="uppercase md:text-sm flex items-center justify-between"
              >
                {{ handleStr(d.course_title, 14) }}
                <span v-if="d.is_private">
                  <EyeOff />
                </span>
              </h5>
              <p class="text-xs text-gray-light">
                {{ formatDateTime(d.start_date) }}
              </p>
              <p class="text-gray-dark text-xs">
                {{ handleHour12(d.start_date) }} -
                {{ handleHour12(d.end_date) }}
              </p>
            </div>
          </div>
        </router-link> -->

        <div v-if="index < dates">
          <div>
            <div class="mb-4 flex justify-between items-baseline">
              <h6
                class="md:text-2xl text-xl font-semibold leading-normal mt-0 text-blacklight"
              >
                {{ i }}'s Workout
              </h6>
              <p class="text-baseline text-sm">
                {{ handleWeekNameShorthand(d[0].start_date) }},
                {{ handleMonthDateTime(d[0].start_date).split(",")[0] }}
              </p>
            </div>
            <div v-for="(sessions, k) in d" :key="k" class="mb-10">
              <router-link
                :to="{
                  name: 'UserSessionDetails',
                  params: { id: sessions.session_id },
                }"
              >
                <div
                  class="flex justify-between p-5 bg-white m-1 duration-500 shadow-md rounded-lg"
                >
                  <div class="flex">
                    <img
                      class="object-cover h-20 w-20 rounded-2xl"
                      :src="baseUrlSrc(sessions.thumbnail_url)"
                      alt="..."
                      @error="defaultImage"
                    />
                    <div class="ml-4 flex flex-col">
                      <p
                        class="capitalize mt-1 font-medium text-2xl tracking-wide"
                      >
                        {{ sessions.title }}
                      </p>
                      <p class="text-sm text-gray-250 mt-3 font-normal">
                        Starting in {{ handleTime(sessions.start_date) }} hours
                      </p>
                    </div>
                  </div>
                  <div class="flex h-11 items-baseline">
                    <p class="text-gray-dark text-2xl mr-4 font-semibold">
                      {{ handleHour12(sessions.start_date) }} -
                      {{ handleHour12(sessions.end_date) }}
                    </p>
                    <button class="rounded-full bg-green-light p-3">
                      <img
                        :src="require('@/assets/img/Play.png')"
                        alt="play.png"
                        class=""
                      />
                    </button>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <button
        v-if="this.dates > 3 && this.dates < 7"
        @click="showThreeMoreClasses"
        class="focus:outline-none ml-2 bg-green-light text-white p-2 rounded-lg"
      >
        Show Mores
      </button>
      <router-link :to="{ name: 'UserCalendar' }" v-else-if="this.dates>=7">
        <button class="text-white bg-green-light px-5 py-3 rounded-lg">Show more</button>
      </router-link>
    </div>
  </section>
</template>

<script>
import ContentLoader from "@/components/vue-spinner/ContentLoader";
import { EyeOff } from "@/components/icons";
import Tooltip from "@/components/Tooltip.vue";
import moment from "moment";

export default {
  name: "NewUpcomingSessions",
  components: {
    ContentLoader,
    EyeOff,
    Tooltip,
  },
  props: {
    data: {
      type: Array,
      default: Array,
    },
  },
  computed: {
    loadingStatus() {
      return this.$store.getters.loadingStatus;
    },
  },
  data() {
    return {
      dates: 3,
      showMore: false,
      isDateWritten: false,
      sessionDates: {},
    };
  },
  methods: {
    handleDate(date) {
      var days = Math.abs(
        moment().set({ hours: 0, minutes: 0 }).diff(moment(date), "days")
      );
      if (days === 0) return "Today";
      else if (days === 1) return "Tomorrow";
      else if (days === 2) return "Day after tomorrow";
      return this.dateFormat(date).split(",")[0];
    },
    handleTime(time) {
      time = this.convertUTCDateToLocalDate(time);
      var hours = moment().diff(moment(time), "hour");
      if (hours > 0) return 0;
      return Math.abs(hours);
    },
    showThreeMoreClasses() {
      this.dates = 7;
    },
  },
  created() {
    let sessionAccordingToDates = {};

    this.data.forEach((element) => {
      const date = this.handleDate(element.start_date);
      if (sessionAccordingToDates[date]) {
        sessionAccordingToDates[date].push(element);
      } else {
        sessionAccordingToDates[date] = [element];
      }
    });
    this.sessionDates = sessionAccordingToDates;
  },
};
</script>
